import type { LanguagePack } from "./languagePack";

import "./Map.css";

interface MapProps {
  languagePack: LanguagePack;
}

const Map = ({ languagePack }: MapProps) => (
  <section className="map">
    <iframe
      title={languagePack.mapTitle}
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3408.4708238581834!2d17.653755276967228!3d46.77535617112571!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4769ac2f7e3202b9%3A0x49461b9d549a7818!2sBabel%20Camp!5e1!3m2!1sen!2sdk!4v1713739429042!5m2!1sen!2sdkhttps://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d27267.76659086546!2d17.635730832537202!3d46.77535617112572!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4769ac2f7e3202b9%3A0x49461b9d549a7818!2sBabel%20Camp!5e1!3m2!1sen!2sdk!4v1713739727828!5m2!1sen!2sdkhttps://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13633.88329543273!2d17.646030515068645!3d46.77535617112572!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4769ac2f7e3202b9%3A0x49461b9d549a7818!2sBabel%20Camp!5e1!3m2!1sen!2sdk!4v1713739767342!5m2!1sen!2sdk"
      allowFullScreen={false}
      loading="lazy"
      referrerPolicy="no-referrer-when-downgrade"
    ></iframe>
  </section>
);

export default Map;
